import { useState, useEffect } from 'react';
import { Box, Typography, Avatar, List, useMediaQuery, MenuItem, Grid, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {  updateTokenAction } from '../../../v2/Onboarding/auth/action';
import DeliveryLocationCard from '../../../v2/Address/Screens/DeliveryLocationCard';
import {logoutUser} from '../../Auth/Login/API/Action';
import { addressDetailAction } from '../../../v2/Address/APIs/action';
import IconReusable from '../../../components/IconReusable';
import { CustomButton, CustomSelect, TextField } from '../../../v2/MUI_custom_component';
import { decodeToken } from '../../../utils/settings';
import { toast } from 'react-toastify';
import Entity from '../../Common/Entity';
import { useBackrouteControl } from '../../../hooks/useSetBackroute';
import { resetEntityState, fetchSuppliers } from '../../Common/Entity/actions/reduxActions';
import OTPScreen from '../ChangeEpin/OTPScreen';
import { getAccountDetailsAction, updateAccountDetailsAction, deleteProfileImageAction } from './API/Action';
import { getCompanySuppliersAction } from '../../../v2/APIs/action';
import GlassModal from '../../../v2/MUI_custom_component/Modal/GlassModal';
import ChangePhone from '../ChangePhone/ChangePhone';

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateBackroute, resetBackroute } = useBackrouteControl();
  const { loginUser, is_PWA, selectedSupplierData } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
      is_PWA: state.loginReducer.is_PWA,
      selectedSupplierData: state.entityReducer.selectedSupplierData,
    };
  });
  const [addressDetails, setAddressDetails] = useState(null);
  const [companyEsiId, setCompanyEsiId] = useState(null);
  const [backrouteChanged, setBackrouteChanged] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [accountDetails, setAccountDetails] = useState(null);
  const [originalAccountDetails, setOriginalAccountDetails] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [hasNewlyUploadedImage, setHasNewlyUploadedImage] = useState(false);
  const [isChangePhoneModalOpen, setIsChangePhoneModalOpen] = useState(false);
  useEffect(() => {
    setBackrouteChanged(false);
    resetBackroute();
  }, []);
  const getSuppliers = async () => {
    const { error, data, message } = await getCompanySuppliersAction();

    if (!error) {
      const company_esi_id = data[0].suppliers_list[0]?.entity_info[0]?.esi_id;

      setCompanyEsiId(company_esi_id);
    }
  };
  useEffect(() => {
    if (is_PWA && !selectedSupplierData) {
      getSuppliers();
    }
  }, [is_PWA , selectedSupplierData]);
  
  const handleLogout = async () => {
    await dispatch(logoutUser());
    navigate('/login');
  };
  const handleChangeMobileNumberlick = () => {
    setIsChangePhoneModalOpen(true);
  };
  const sections = [
    {
      title: 'Business Overview',
      items: [
        { label: 'Firms', key: 'firms', path: '/my-account/firm-details', visible: !is_PWA },
        {
          label: 'Staff',
          path: '/my-account/employee-details',
          visible: !is_PWA,
          key: 'staff',
        },
        {
          label: 'Address',
          path: '/my-account/address-details',
          visible: true,
          key: 'address',
        },
      ],
      visible: !is_PWA,
    },
    {
      title: 'Profiler',
      path: '/my-account/profiler',
      visible: !is_PWA,
      items: [],
    },
    {
      title: 'Settings',
      items: [
        {
          label: 'Change ePin',
          onClick: () => handleChangePinClick(),
          visible: !is_PWA,
        },
        {
          label: 'Change Mobile Number',
          onClick: () => handleChangeMobileNumberlick(),
          visible: !is_PWA,
        },
      ],
      visible: !is_PWA,
    },
    {
      title: 'Help',
      items: [
        {
          label: 'Contact Us',
          path: '/my-account/contact-us',
          visible: true,
        },
        {
          label: 'FAQs',
          path: is_PWA ? '/pwa-faq' : '/my-account/faq',
          visible: true,
        },
        {
          label: 'Policies',
          path: '/my-account/policies',
          visible: true,
        },
      ],
      visible: true,
    },
  ];
  const visibleSections = sections
  .map((section) => ({
    ...section,
    items: section.items.filter((item) => {
      const isVisible = item.visible !== false;
      const isDenied = accountDetails?.sections_denied?.includes(item.key);
      return isVisible && !isDenied;
    })
  }))
  .filter((section) => (section.items.length > 0 || section.path) && section.visible);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const isMobile = useMediaQuery('(max-width:1279px)');
  const [decodedData, setDecodedData] = useState({});
  const handleChangePinClick = () => {
    setIsOTPModalOpen(true);
  };
  useEffect(() => {
    const getTokenData = async () => {
      const decoded = await decodeToken();
      setDecodedData(decoded);
      setSelectedCompany(decoded?.default_company_info?.company_id);
    };
    getTokenData();
  }, []);
  useEffect(() => {
    if (loginUser && !is_PWA && isMobile) {
      dispatch(fetchSuppliers());
    }
  }, [loginUser, is_PWA]); 
  const onSupplierChange = () => {
    if (!backrouteChanged) {
      updateBackroute({
        path: '/',
      });
      setBackrouteChanged(true);
    }
  }
  const handleCompanyChange = async (event) => {
    setLoading(true);
    const { data, error, message } = await updateTokenAction({ company_id: event.target.value });
    setTimeout(() => setLoading(false), 500);
    if (!error) {
      setSelectedCompany(event.target.value);
      localStorage.setItem('token', data);
      dispatch(resetEntityState());
      setTimeout(() => {
        dispatch(fetchSuppliers());
      }, 100);
    } else {
      toast.error(message);
    }
  };
  const handleOTPSuccess = (result) => {
    setIsOTPModalOpen(false);
  };
  
  const handleUpdateProfile = async () => {
    if (!accountDetails || !originalAccountDetails) return;
    setUpdateLoading(true);
    const updateData = {
      email: null,
      fullname: null,
      profile_image: null
    }
    console.log({ accountDetails, originalAccountDetails });
    if (accountDetails.full_name !== originalAccountDetails.full_name) {
      updateData.fullname = accountDetails.full_name;
    }
    if (accountDetails.email !== originalAccountDetails.email) {
      updateData.email = accountDetails.email;
    }
    if (hasNewlyUploadedImage && accountDetails.profile_image && accountDetails.profile_image.file_data) {
      updateData.profile_image = {
        file_data: accountDetails.profile_image.file_data,
        media_type: accountDetails.profile_image.media_type,
        file_name: accountDetails.profile_image.file_name
      };
    }
    if (Object.keys(updateData).length === 0) {
      setEditModalOpen(false);
      setUpdateLoading(false);
      return;
    }
    
    const { error, message } = await updateAccountDetailsAction(updateData);
    setUpdateLoading(false);
    
    if (!error) {
      toast.success(message);
      setEditModalOpen(false);
      setHasNewlyUploadedImage(false);
      getAccoutDetail();
    } else {
      toast.error(message);
    }
  };
  
  const handleDeleteProfileImage = async () => {
    const isApiImage = accountDetails?.profile_image?.file_data && !hasNewlyUploadedImage;
    if (isApiImage) {
      setUpdateLoading(true);
      const { error, message } = await deleteProfileImageAction();
      setUpdateLoading(false);
      
      if (!error) {
        toast.success('Profile image deleted successfully');
        setAccountDetails(prev => ({
          ...prev,
          profile_image: null
        }));
        setHasNewlyUploadedImage(false);
      } else {
        toast.error(message || 'Failed to delete profile image');
      }
    } else {
      setAccountDetails(prev => ({
        ...prev,
        profile_image: null
      }));
      setHasNewlyUploadedImage(false);
    }
  };
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result.split(',')[1];
        setAccountDetails(prev => ({
          ...prev,
          profile_image: {
            file_data: base64,
            media_type: file.type,
            file_name: file.name
          }
        }));
        setHasNewlyUploadedImage(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleChangeUserDetails = () => {
    if (originalAccountDetails) {
      setAccountDetails({ ...originalAccountDetails });
      setHasNewlyUploadedImage(false);
    }
    setEditModalOpen(true);
  };
  
  const hasChanges = () => {
    if (!accountDetails || !originalAccountDetails) return false;
    const nameChanged = accountDetails.full_name !== originalAccountDetails.full_name;
    const emailChanged = accountDetails.email !== originalAccountDetails.email;
    const imageChanged = hasNewlyUploadedImage;
    return nameChanged || emailChanged || imageChanged;
  };
  const getAccoutDetail = async () => {
    setLoading(true);
    const { data, error, message } = await getAccountDetailsAction();
    setLoading(false);
    if (!error) {
      setAccountDetails(data);
      setOriginalAccountDetails(data);
      setHasNewlyUploadedImage(false);
    } else {
      setAccountDetails(data);
      setOriginalAccountDetails(data);
      setHasNewlyUploadedImage(false);
    }
  };
  useEffect(() => {
    getAccoutDetail();
  }, []);
  const handleChangePhoneSuccess = (newPhoneNumber) => {
    toast.success('Mobile number changed successfully!');
    setIsChangePhoneModalOpen(false);
    handleLogout();
  };
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column', gap: 2 }}>
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          boxShadow: 'none',
          background: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
                variant="determinate"
                value={100}
                size={80}
                thickness={3}
                sx={{
                    color: "#F7F7F7",
                    position: "absolute",
                    left: "-17%",
                    top: "-17%",
                    transform: "translate(-50%, -50%) rotate(-90deg)",
                }}
            />
            <CircularProgress
                variant="determinate"
                value={accountDetails?.profiler_percentage || 75}
                size={80}
                thickness={3}
                sx={{
                    color: "#008000",
                    position: "absolute",
                    left: "-17%",
                    top: "-17%",
                    "& .MuiCircularProgress-circle": {
                        strokeLinecap: "round",
                    },
                    transform: "translate(-50%, -50%) rotate(-90deg)",
                }}
            />
            <Avatar
              sx={{ width: 60, height: 60, bgcolor: '#d9d9d9' }}
              alt={accountDetails?.full_name || loginUser?.first_name}
              src={accountDetails?.profile_image?.file_data ? `data:${accountDetails.profile_image.media_type};base64,${accountDetails.profile_image.file_data}` : loginUser?.profile_image}
            />
            <Box
              sx={{
                  position: "absolute",
                  bottom: -15,
                  left: "50%",
                  transform: "translateX(-50%)",
                  bgcolor: "white",
                  px: 1,
                  py: 0.2,
                  borderRadius: "12px",
                  border: "1px solid #008000",
              }}
          >
              <Typography
                variant="caption"
                sx={{ fontSize: "0.7rem", fontWeight: 500 }}
              >
              {accountDetails?.profiler_percentage || 75}%
              </Typography>
          </Box>
                        
          </Box>
          <Box sx={{ ml: 3, display: 'flex', gap: 2, flexDirection: 'column'}}>
            <Typography
              variant='h1'
            >
              {accountDetails?.full_name || `${loginUser.first_name} ${loginUser.last_name}`}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconReusable name="Call1" size={16} color='#666666' />
                <Typography
                  variant='body1'
                  sx={{ color: '#666666' }}
                >
                  {accountDetails?.phone_no || loginUser.phone_no}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconReusable name="Mail" size={16} color='#666666' />
                <Typography
                  variant='body1'
                  sx={{ color: '#666666' }}
                >
                  {accountDetails?.email || loginUser.email}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box onClick={handleChangeUserDetails} sx={{ cursor: 'pointer' }}>
          <IconReusable name="Edit" size={20} color='#333'/>
        </Box>
      </Box>
      {loginUser && !is_PWA && isMobile && (
        <Grid container spacing={1}>
          <Grid item xs={6} md={4}>
              <Box sx={{ mb: 2 }}>
                <CustomSelect
                  size="small"
                  value={selectedCompany}
                  onChange={handleCompanyChange}
                  label="Firm"
                  fullWidth
                  disabled={decodedData?.all_companies_info?.length === 1 || loading}
                >
                  {decodedData?.all_companies_info?.map((company, idx, arr) => (
                    <MenuItem
                      key={company.company_id}
                      value={company.company_id}
                    >
                      {company.company_name}
                    </MenuItem>
                  ))}
                </CustomSelect>
              </Box>
          </Grid>
          <Grid item xs={6} md={4}>
            <Entity
              supplierLabel="Manufacturer"
              gridSizes={{
                supplier: { xs: 12, sm: 12 },
              }}
              onSupplierChange={onSupplierChange}
              showManufacturerSelect={true}
              forceRefresh={false}
              showEntitySelect={false}
              autoFetch={false}
            />
          </Grid>
        </Grid>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, mb: 2 }}>
        {visibleSections
          .map((section, idx) => (
            <Box
              key={idx}
              sx={{ display: 'flex', flexDirection: 'column', gap: 0.4,}}
            >
              {section.path ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #D9D9D9',
                    py: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate(section.path)}
                >
                  <Typography variant='h2'>{section.title}</Typography>
                  <Box sx={{ width: 24, height: 24 , alignItems: 'center', display: 'flex' , justifyContent: 'center' }}>
                    <IconReusable name="ArrowRight" size={12} color='#333'/>
                  </Box>
                </Box>
              ) : (
                <Typography variant='h2'>{section.title}</Typography>
              )}
              <List sx={{ p: 0 }}>
                {section.items.map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: '1px solid #D9D9D9',
                      py: 1,
                      cursor: 'pointer',
                    }}
                    onClick={() => item.onClick ? item.onClick() : navigate(item.path)}
                  >
                    <Typography variant='labelD'>{item.label}</Typography>
                    <Box sx={{ width: 24, height: 24 , alignItems: 'center', display: 'flex' , justifyContent: 'center' }}>
                      <IconReusable name="ArrowRight" size={12} color='#333'/>
                    </Box>
                  </Box>
                ))}
              </List>
            </Box>
        ))}
      </Box>

      {!is_PWA && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #D9D9D9',
            py: 0.5,
          }}
          onClick={handleLogout}
        >
          <Typography variant='h2'>Logout</Typography>
            <IconReusable name="LogoutOutlined" size={24} color='#333'/>
        </Box>
      )}

      <Box sx={{ textAlign: 'end', mt: 1 }}>
        <Typography
          variant='body1'
          sx={{ color: '#8c8c8c', mb: 2 }}
        >
          Version V2.02
        </Typography>
      </Box>

      <OTPScreen
        open={isOTPModalOpen}
        onClose={() => setIsOTPModalOpen(false)}
        onSuccess={handleOTPSuccess}
      />
      <GlassModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        title="User Details"
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3,}}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Avatar
                sx={{ width: 72, height: 72, bgcolor: '#d9d9d9' }}
                alt={accountDetails?.full_name || loginUser?.first_name}
                src={accountDetails?.profile_image?.file_data ? `data:${accountDetails.profile_image.media_type};base64,${accountDetails.profile_image.file_data}` : loginUser?.profile_image}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <input
                  accept="image/jpeg,image/png,image/jpg,.heic,.HEIC"
                  style={{ display: 'none' }}
                  id="profile-image-upload"
                  type="file"
                  onChange={handleImageUpload}
                />
                <label htmlFor="profile-image-upload">
                  <CustomButton
                    variant="contained"
                    size="small"
                    component="span"
                    label={accountDetails?.profile_image?.file_data ? "Replace " : "Upload Photo"}
                    disabled={loading || updateLoading}
                  />
                </label>
                {(accountDetails?.profile_image?.file_data) && (
                  <CustomButton
                    variant="text"
                    size="small"
                    onClick={handleDeleteProfileImage}
                    label={updateLoading ? "Deleting..." : "Delete"}
                    disabled={updateLoading || loading}
                    startIcon={updateLoading ? <CircularProgress size={14} color="inherit" /> : null}
                  />
                )}
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="Name"
                variant="standard"
                size="small"
                fullWidth
                value={accountDetails?.full_name || `${loginUser.first_name} ${loginUser.last_name}`}
                onChange={(e) => setAccountDetails({ ...accountDetails, full_name: e.target.value })}
              />
              <TextField
                fetchedState={true}
                label="Mobile Number"
                variant="standard"
                size="small"
                fullWidth
                value={accountDetails?.phone_no || loginUser.phone_no}
              />
              <TextField
                label="Email"
                variant="standard"
                size="small"
                fullWidth
                placeholder="Add Email abc@example.com"
                value={accountDetails?.email }
                onChange={(e) => setAccountDetails({ ...accountDetails, email: e.target.value })}
              />
            </Box>
          </Box>
          <CustomButton
            variant="contained"
            onClick={handleUpdateProfile}
            label={updateLoading ? "Saving..." : "Save"}
            disabled={updateLoading || !hasChanges() || loading}
            startIcon={updateLoading ? <CircularProgress size={16} color="inherit" /> : null}
          />
        </Box>
      </GlassModal>
      <ChangePhone
        open={isChangePhoneModalOpen}
        onClose={() => setIsChangePhoneModalOpen(false)}
        currentPhone={loginUser?.phone_no}
        onSuccess={handleChangePhoneSuccess}
      />
    </Box>
  );
};

export default Profile;
